import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get } from '../../modules/ocr/ocrIngestion';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const ocrIngestionId = _.get(ownProps, ['match', 'params', 'ocrIngestionId']);
	const ocrIngestion = ocrIngestionId
		? _.get(state.maps, ['ocrIngestion', ocrIngestionId])
		: undefined;

	return {
		ocrIngestion,
		userMap: state.maps.user,
		carrierMap: state.maps.carrier,
		supplierMap: state.maps.supplier,
		terminalMap: state.maps.terminal,
		resourceMap: state.maps.resource,
		stationDeliveryMap: state.maps.stationDelivery,
		stationInvoiceMap: state.maps.stationInvoice,
		ocrIngestionDocumentMap: state.maps.ocrIngestionDocument,
		ocrGuideMap: state.maps.ocrGuide,
		stationMap: state.maps.station,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			ocrIngestionAdd: add,
			ocrIngestionUpdate: update,
			ocrIngestionGet: get,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
